module.exports = __webpack_public_path__ + "static/media/madequimica.91d50b0f.webp";